import {
  SEND_BROADCAST,
  SEND_BROADCAST_SUCCESS,
  SEND_BROADCAST_ERROR,
  RESET_BROADCAST,
} from './constants';

/**
 * Send a broadcast to N clients. Body shape:
 *   { title, body, recipients: [clientId] | filter: 'all' }
 */
export function sendBroadcast(payload) {
  return { type: SEND_BROADCAST, payload };
}
export function sendBroadcastSuccess(result) {
  return { type: SEND_BROADCAST_SUCCESS, payload: result };
}
export function sendBroadcastError(err) {
  return { type: SEND_BROADCAST_ERROR, err };
}
export function resetBroadcast() {
  return { type: RESET_BROADCAST };
}
